import { useRecoilState } from 'recoil'
import { useTranslation } from 'react-i18next'

import { itemSelector } from '@/atoms/_editorAtoms'

import { Flex } from '@/components/priority/Flex/Flex'
import { ToggleSwitch } from '@/components/global/ToggleSwitch/ToggleSwitch'
import { Text } from '@/components/priority/Text/Text'

import { useIsAdmin } from '@/hooks/utility/useIsAdmin'

export const HideInPdf = ({ selectedItem }) => {
  const { t } = useTranslation()
  const isAdmin = useIsAdmin()
  const [hideInPdf, setHideInPdf] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'hideInPdf' }),
  )

  if (!isAdmin) return null

  return (
    <>
      <Text margin="0 0 4px">
        {t('editor.menus.properties.elements.hideInPdfButton')}
      </Text>
      <Text size="11px" color="gray2" margin="0 0 12px">
        {t('editor.menus.properties.elements.hideInPdfLabel')}
      </Text>
      <Flex margin="0 0 24px">
        <ToggleSwitch value={[hideInPdf, setHideInPdf]} />
      </Flex>
    </>
  )
}
